import { Attachment } from '../attachment/attachment.types';
import { OfferKind, OfferStatus } from '../offer/offer.enums';
import { Visibility } from '../visibility/visibility.types';

export type AutomatedActionOffer = {
  id: number;
  kind: OfferKind;
  location: string;
  slug: string;
  status: OfferStatus;
  title: string;
};

export type AutomatedAction =
  | {
      kind: AutomatedActionKind.SendEmail;
      data: {
        from: number | null;
        subject: string;
        bodyHtml: string;
        private: boolean;
        adminIds: number[];
        signature: boolean;
        visibility: Visibility;
        sendAfterAtHour?: number | null;
        sendAfterAtMinute?: number | null;
        sendAfterDays?: number | null;
        sendAtTimezone?: string | null;
        attachmentIds: number[];
      };
      id?: number;
      references?: { attachments: Attachment[] };
      _destroy?: boolean;
    }
  | {
      kind: AutomatedActionKind.AddNote;
      data: {
        body: string;
        bodyJson: object | null;
        bodyHtml: string;
        private?: boolean;
        adminIds?: number[];
        visibility: Visibility;
      };
      id?: number;
      _destroy?: boolean;
    }
  | {
      kind: AutomatedActionKind.AddFollowers;
      data: {
        adminIds: number[];
      };
      id?: number;
      _destroy?: boolean;
    }
  | {
      kind: AutomatedActionKind.AddTask;
      data:
        | {
            adminIds: number[];
            dueDateType: 'relative' | null;
            dueDateUnit: string | null;
            dueDateValue: string | null;
            title: string;
            timezone: string | null;
          }
        | {
            adminIds: number[];
            dueDateType: 'absolute' | null;
            dueDateValue: string | null;
            title: string;
            timezone: string;
          };
      id?: number;
      _destroy?: boolean;
    }
  | {
      kind: AutomatedActionKind.AddTags;
      data: {
        tags: string[];
      };
      id?: number;
      _destroy?: boolean;
    }
  | {
      kind: AutomatedActionKind.EvaluationRequest;
      data: {
        interviewTemplateId: number | null;
        adminIds: number[];
      };
      id?: number;
      _destroy?: boolean;
    }
  | {
      kind: AutomatedActionKind.AssignTo;
      data: {
        offerIds: number[];
      };
      id?: number;
      references?: { offers: AutomatedActionOffer[] };
      _destroy?: boolean;
    };

export enum AutomatedActionKind {
  SendEmail = 'send_email',
  AddTags = 'add_tags',
  AddNote = 'add_note',
  AddTask = 'add_task',
  EvaluationRequest = 'request_evaluation',
  AddFollowers = 'add_followers',
  AssignTo = 'assign',
}
